// Fancybox Config
$('.scrollbar_image .main_image a,.main_artical_slide .article_slide a,.mb_bottom .elementor-widget-container a').fancybox({
  buttons: [
    "slideShow",
    "thumbs",
    "zoom",
    "fullScreen",
    "share",
    "close"
  ],
  loop: false,
  protect: true
});


// custom banner section
$( window ).on("load", function() {
$(document).find('.custom_banner-img .slideshow .slideshow__slide').removeClass('ann_slider ');
 $(document).find('.main_product .product__media-item').removeClass('ann_slider ');
});

 $('.custom_banner-img .slideshow').slick({
      dots: false,
      infinite: true,
      // autoplay: true,
      // autoplaySpeed: 2000,
      speed: 1000,
      slidesToShow: 1,
      arrows: true,
      prevArrow:
      '<button type="button" class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
     nextArrow:
      '<button type="button" class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>',
     responsive: [
      {
      breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
});

  if ($(window).width() < 990) {
    $(".logo_slider").slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      dots: false,
      cssEase: "linear",
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      swipeToSlide: true,   
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 4,
            
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 3,
         
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
  }


 const tabTitles = document.querySelectorAll('.tab_btn');
  // if (tabTitles.length > 0) {
  //     tabTitles[0].classList.add('tab_title_active');
  // }
  tabTitles.forEach(tabTitle => {
      tabTitle.addEventListener('click', function() {
          // Remove 'tab_title_active' class from all tab titles
          tabTitles.forEach(tab => tab.classList.remove('active'));
          // Add 'tab_title_active' to the clicked tab
          this.classList.add('active');
        const viewAllButton = document.querySelectorAll('.tab_collection_viewall');
        const dataId = this.getAttribute("data-hide");
        viewAllButton.forEach((button)=> {
          let buttonID = button.getAttribute("data-hide");
          console.log(buttonID)
          if(dataId == buttonID){
            button.classList.add('viewall_button_active')
          }
          else{
             button.classList.remove('viewall_button_active')
          }
        });
  
          // Fetch data for the clicked tab
          const dataUrl = this.getAttribute("data-url");
          // Fetch and update content
          fetch(dataUrl)
              .then(response => {
                  if (!response.ok) throw new Error('Network response was not ok');
                  return response.text();
              })
              .then(htmlText => {
                  const doc = new DOMParser().parseFromString(htmlText, "text/html");
                // console.log(doc)
                  const extractedHtml = doc.querySelector('#product-grid');
  
                  if (extractedHtml) {
                      const collectionGrid = extractedHtml.innerHTML;
                      // console.log(collectionGrid)
                      const productGridElements = document.querySelectorAll('.show-slider-component-collection');
                      
                      // Update all grid elements
                      productGridElements.forEach(grid => grid.innerHTML = collectionGrid);
                  }
              })
              .catch(error => console.error('Error fetching data:', error.message));
      });
  });


$(document).on("click", ".cstm_drawer_main button",function(){
  $(".itg_popup_wr").addClass("visible");
  $("body").css("overflow", "hidden");
});
$(document).on("click", ".itg_popup_overlay", function () {
  $(".itg_popup_wr").removeClass("visible");
  $("body").css("overflow", "auto");
});
$(document).on("click", ".main_links.accordian_grid .accordian-box,.main_links.accordian_grid .menu_item_acc", function() {
  if ($(this).closest('.main_links.accordian_grid').find(".accordion_bodys").is(':visible')) {
    $(this).closest('.main_links.accordian_grid').find(".accordion_bodys").slideUp(500);
    $(this).removeClass('rotate_icon');
  } else {
    $(this).closest('.main_links.accordian_grid').find(".accordion_bodys").slideDown(500);
    $(this).addClass('rotate_icon');
  }
});
$(document).on('click', '.itg_popup_close',function(){
  $(document).find('.itg_popup_wr').removeClass('visible');
   $("body").css("overflow", "auto");
})

$('.main_artical_slide').slick({
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 3,
      arrows: true,
      prevArrow:
      '<button type="button" class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
     nextArrow:
      '<button type="button" class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>',
     responsive: [
      {
      breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
});


$('.slider_one').slick({
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      arrows: true,
      prevArrow:
      '<button type="button" class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"/></svg></button>',
     nextArrow:
      '<button type="button" class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 12.5 25 20l-7.5 7.5"/></svg></button>'
});

// blog faqs
$(".blog-related-faq .elementor-accordion-item .elementor-tab-content").slideUp(300);
$(document).on("click",".blog-related-faq .elementor-accordion-item .elementor-tab-title",function() {
  
    if ($('.blog-related-faq .elementor-accordion-item .elementor-tab-content').is(':visible')) {
        $(".blog-related-faq .elementor-accordion-item .elementor-tab-content").slideUp(300);
        $(".blog-related-faq .elementor-accordion-item .elementor-tab-title").removeClass('accordion_active')
      }
      if ($(this).next(".blog-related-faq .elementor-accordion-item .elementor-tab-content").is(':visible')) {
          $(this).next(".blog-related-faq .elementor-accordion-item .elementor-tab-content").slideUp(300);
      } else {
        $(this).next(".blog-related-faq .elementor-accordion-item .elementor-tab-content").slideDown(300);
        $(this).addClass('accordion_active')
        
      }
  });

// review app js for css
var formCss = setInterval(function() {
  let appEmbed = document.querySelector('#shopify-block-google_reviews_carousel_widget_block_whknDX');
  if (appEmbed) {
    let maingoogleicon = appEmbed.querySelectorAll('.reputon-review-header');
    let reviewstar = appEmbed.querySelectorAll('.reputon-review-rating-stars');
    let reviewsvg = appEmbed.querySelectorAll('.reputon-text svg');
    maingoogleicon.forEach(function(element) {
      if (element) {
        if(window.innerWidth < 559){
        element.setAttribute('style', 'justify-content: flex-start');
        // clearInterval(formCss);
        }
      }
    });
    reviewstar.forEach(function(element) {
      if (element) {
        if(window.innerWidth < 375){
        element.setAttribute('style', 'gap: 0');
        // clearInterval(formCss);
        }
      }
    });
    reviewsvg.forEach(function(element) {
      if (element) {
        element.setAttribute('style', 'min-width: 15px;height:15px');
      }
      if(window.innerWidth < 375){
        element.setAttribute('style', 'min-width: 10px;height:10px');
        // clearInterval(formCss);
      }
    });
  }
}, 200);


$('.review_slide-one,.review_slide-two').slick({
  slidesToShow: 1,    
  slidesToScroll: 1,  
  autoplay: true,     
  autoplaySpeed: 2000,
  arrows: false,      
  dots: true,  
  infinite: true,
  adaptiveHeight: true
});

if (document.querySelector('#shopify-block-bold_subscriptions_bsub_widget_block_pBPjL7 .bsub-widget')) {
    // Hide the element with ID 'square-placement' using !important
  setTimeout(() => {
    const squarePlacement = document.querySelector('square-placement');
    if (squarePlacement) {
        squarePlacement.style.setProperty('display', 'none', 'important');
    }
    }, 2000)
    
    // Hide the element with ID 'shopify-block-sezzle_widget_widget_block_rYbnd8' using !important
    const sezzleWidget = document.querySelector('#shopify-block-sezzle_widget_widget_block_rYbnd8');
    if (sezzleWidget) {
        sezzleWidget.style.setProperty('display', 'none', 'important');
    }
}

if(document.querySelectorAll('.bsub-widget').length > 0){
  setTimeout(() => {
    let checkInput = $('input[data-bsub-delivery-frequency-option]:checked').closest('.bsub-option-container').find('.bsub-widget__plan-pricing span:first').text();
    $(document).find('.price__regular .price-item').text(checkInput);
    let mainPrice = $(document).find('.productDetail__Price').data('subprice');
          console.log(mainPrice);
        setTimeout(function(){
         $(document).find('.product__info-wrapper .price__sale s.price-item.price-item--regular').text(mainPrice);
        },400);
   }, 1000);
   $(document).on("click",".bsub-widget__group",function() {
      let thsInput = $(this).find('input').val();
      if(thsInput == 'once'){
        let checkInput = $(document).find('.productDetail__Price').attr('data-subprice');
        let checkDiscount = $(document).find('.black_friday_cyber').attr('data-discount');
        $(document).find('.price__regular .price-item').text(checkInput);
        $(document).find('.black_friday_cyber .price-item.price-item--sale.price-item--last').text(checkDiscount);
      }else{
         let checkInput = $('input[data-bsub-delivery-frequency-option]:checked').closest('.bsub-option-container').find('.bsub-widget__plan-pricing span:first').text();
         let mainPrice = $(document).find('.productDetail__Price').data('subprice');
          console.log(mainPrice);
        setTimeout(function(){
         $(document).find('.product__info-wrapper .price__sale s.price-item.price-item--regular').text(mainPrice);
        },400);
         $(document).find('.price__regular .price-item').text(checkInput);
      }
   });
   $(document).on("click",".bsub-option-container",function() {
     let checkInput = $(this).find('span[data-bsub-per-delivery-price]').text();
     $(document).find('.price__regular .price-item').text(checkInput);
   });
}


if (window.location.href === "https://lashgod.ca/pages/brand-ambassador") {
    window.location.replace("https://lashgod.goaffpro.com/");
}


